// extracted by mini-css-extract-plugin
export default {"manageAgentWrapper":"ManageAgent_manageAgentWrapper__MlYAb","card":"ManageAgent_card__+ZrxE","title":"ManageAgent_title__eDdxh"};